import { AuthenticatedHttp } from '../../http/axios';

export const getMemberToken = async (courseId) =>
  AuthenticatedHttp.get('/members/courses/token/').then(({ data }) => ({ ...data, courseId }));
